export default {
  title: {
    hmManagement: 'HM Management',
    roleManagement: 'Role Management',
    hmAdd: 'Add HM',
    hmEdit: 'Edit HM',
    resetPassword: 'Reset Password'
  },
  menu: 'HM Management',
  label: {
    checkAll: 'All',
    firstName: 'First Name',
    lastName: 'Last Name',
    company: 'Company',
    email: 'Email Address',
    updateTime: 'Update Time',
    status: 'Status',
    active: 'Activity Status',
    option: 'Operation',
    companyName: 'Company Name',
    addHM: 'Add HM',
    editHM: 'Edit HM',
    activeMonth: 'Last Active',
    resetPassword: 'Reset Password',
    password: 'New Password:',
    confirmPassword: 'Password Again:',
    questionnaire: 'Questionnaire',
    emailTemplate: 'Email Template',
    oneMonth: 'One Month',
    twoMonth: 'Two Months',
    threeMonth: 'Three Months',
    fourMonth: 'Four Months',
    fiveMonth: 'Five Months',
    sixMonth: 'Six Months'
  },
  placeholder: {
    firstName: 'Please input first name',
    lastName: 'Please input last name',
    company: 'Please select company',
    email: 'Please input email',
    password: 'Please input password',
    confirmPassword: 'Please input password again',
    questionnaire: 'Please select questionnaire',
    emailTemplate: 'Please select email template'
  },
  btn: {
    addHM: 'Add HM',
    survey: 'Invite Hiring Manager to take survey',
    resetPassword: 'Reset Password'
  },
  message: {
    optionSuccess: 'Option Success',
    optionField: 'Option Field',
    hmRequired: 'This field is required',
    emailExist: 'a hm is already registered with this email address',
    emailValid: 'Enter a valid e-mail address.',
    confirmPasswordSame: 'Please make sure the two passwords are the same.',
    resetPasswordError: 'Can not reset password more than 5 times in 24 hours.',
    resetPasswordSuccess: 'Reset password email has sent, please check in few minutes.',
    sendSurvey: 'Please select survey template and email template',
    checkedLeastOneHm: 'Please select at least one HM'
  }
}
